import '../styles/Services.css';

function Services() {
  const services = [
    {
      number: '01',
      title: 'Lean Consulting',
      image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=600&h=350&fit=crop',
      bullets: [
        'Improve process flow and eliminate waste for faster, more reliable operations.',
        'Simplify work, reduce delays and improve visibility across your organisation.',
        'Deliver value more efficiently with improvements teams can sustain independently.'
      ]
    },
    {
      number: '02',
      title: 'Lean Six Sigma',
      image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=600&h=350&fit=crop',
      bullets: [
        'Combine speed with quality by reducing variation, defects and recurring problems.',
        'Use structured, data-led problem solving to improve consistency and process performance.',
        'Ideal for organisations where quality and reliability are critical.'
      ]
    },
    {
      number: '03',
      title: 'Operational Excellence',
      image: 'https://images.unsplash.com/photo-1504384308090-c894fdcc538d?w=600&h=350&fit=crop',
      bullets: [
        'Build a sustainable culture of continuous improvement organisation-wide.',
        'Embed better ways of working and develop your team\'s improvement capability.',
        'Create systems that keep improvements alive long after we leave.'
      ]
    },
    {
      number: '04',
      title: 'Cross-Functional Improvement',
      image: 'https://images.unsplash.com/photo-1552664730-d307ca884978?w=600&h=350&fit=crop',
      bullets: [
        'Improve processes that span multiple teams, departments or locations.',
        'Map complex workflows and identify interconnected inefficiencies.',
        'Coordinate change effectively across organisational boundaries.'
      ]
    },
    {
      number: '05',
      title: 'Leadership & Capability Building',
      image: 'https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?w=600&h=350&fit=crop',
      bullets: [
        'Develop improvement skills through tailored coaching, training and problem-solving.',
        'Build confidence so your teams can lead improvements independently.',
        'Structured programmes designed around your team\'s specific needs.'
      ]
    },
    {
      number: '06',
      title: 'Transformation Support',
      image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=600&h=350&fit=crop',
      bullets: [
        'Lead major operational transformation from diagnosis through embedded change.',
        'Understand current challenges and redesign key processes.',
        'Manage change and measure results at every stage of the journey.'
      ]
    }
  ];

  return (
    <div className="services">
      {/* Header */}
      <section className="services-header">
        <div className="services-header-overlay"></div>
        <div className="services-header-content">
          <h2 className="services-heading">What We Do</h2>
          <h1 className="services-title">Six service areas. One integrated approach.</h1>
          <p className="services-subtitle">
            Our services are designed to work independently or together, depending on where your organisation needs the most support.
          </p>
        </div>
      </section>

      {/* Services Grid */}
      <section className="services-grid">
        <div className="services-container">
          {services.map((service, index) => (
            <div key={index} className="service-card">
              <div className="service-image-wrapper">
                <img src={service.image} alt={service.title} className="service-image" />
              </div>
              <div className="service-number">{service.number}</div>
              <h3 className="service-title">{service.title}</h3>
              <ul className="service-bullets">
                {service.bullets.map((point, i) => (
                  <li key={i}>{point}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </section>

      {/* Approach Section */}
      <section className="approach">
        <div className="approach-container">
          <h2 className="approach-heading">Our Approach</h2>
          <div className="approach-content">
            <div className="approach-column">
              <div className="approach-col-image">
                <img
                  src="https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=400&h=250&fit=crop"
                  alt="Assessment and analysis"
                  className="approach-col-img"
                />
              </div>
              <h3 className="approach-title">Assessment & Analysis</h3>
              <ul className="approach-text bullet-list">
                <li>Thorough assessment of your current state</li>
                <li>Identify gaps, inefficiencies, and opportunities</li>
              </ul>
            </div>
            <div className="approach-column">
              <div className="approach-col-image">
                <img
                  src="https://images.unsplash.com/photo-1542744173-8e7e53415bb0?w=400&h=250&fit=crop"
                  alt="Strategy and design session"
                  className="approach-col-img"
                />
              </div>
              <h3 className="approach-title">Strategy & Design</h3>
              <ul className="approach-text bullet-list">
                <li>Tailored solutions aligned to your objectives</li>
                <li>Fit with your organisational culture</li>
              </ul>
            </div>
            <div className="approach-column">
              <div className="approach-col-image">
                <img
                  src="https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=400&h=250&fit=crop"
                  alt="Implementation and support"
                  className="approach-col-img"
                />
              </div>
              <h3 className="approach-title">Implementation & Support</h3>
              <ul className="approach-text bullet-list">
                <li>Guide your team through implementation</li>
                <li>Ensure adoption and embed sustainable improvements</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="benefits">
        <div className="benefits-container">
          <h2 className="benefits-heading">Why Choose CKS Innovation</h2>
          <div className="benefits-list">
            <div className="benefit-item">
              <div className="benefit-icon">✓</div>
              <div className="benefit-text">
                <h4>Chartered Expertise</h4>
                <ul className="bullet-list">
                  <li>CMC chartered status</li>
                  <li>Lean Six Sigma Green Belt certifications</li>
                </ul>
              </div>
            </div>
            <div className="benefit-item">
              <div className="benefit-icon">✓</div>
              <div className="benefit-text">
                <h4>Proven Track Record</h4>
                <ul className="bullet-list">
                  <li>10+ years of experience</li>
                  <li>Transformational results across diverse industries</li>
                </ul>
              </div>
            </div>
            <div className="benefit-item">
              <div className="benefit-icon">✓</div>
              <div className="benefit-text">
                <h4>Sustainable Change</h4>
                <ul className="bullet-list">
                  <li>Embed improvements that last</li>
                  <li>Not quick fixes that fade away</li>
                </ul>
              </div>
            </div>
            <div className="benefit-item">
              <div className="benefit-icon">✓</div>
              <div className="benefit-text">
                <h4>Global Reach</h4>
                <ul className="bullet-list">
                  <li>UK and international presence</li>
                  <li>Experience across European and global markets</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Services;
